import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router';

import AdminAddBookPage from './components/05_pages/AdminAddBookPage/AdminAddBookPage';
import AdminDetailPage from './components/05_pages/AdminDetailPage/AdminDetailPage';
import AdminEditBookPage from './components/05_pages/AdminEditBookPage/AdminEditBookPage';
import AdminOverviewPage from './components/05_pages/AdminOverviewPage/AdminOverviewPage';
import DetailPage from './components/05_pages/DetailPage/DetailPage';
import ErrorPage from './components/05_pages/ErrorPage/ErrorPage';
import OverviewPage from './components/05_pages/OverviewPage/OverviewPage';
import LoginPage from './components/05_pages/LoginPage/LoginPage';
import Alerts from './components/Alerts';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import AuthProvider from './components/AuthProvider';
import UserOverviewPage from './components/05_pages/UserOverviewPage/UserOverviewPage';
import { UserRoleProvider, useUserRoleContext } from './contexts/UserRoleContext';
import Loader from './components/01_atoms/Loader/Loader';
import Centered from './components/01_atoms/Centered/Centered';

function HomeRedirect() {
  const { isAdmin, isLoading } = useUserRoleContext();

  if (isLoading) {
    return (
      <main>
        <Centered>
          <Loader />
        </Centered>
      </main>
    );
  }

  return isAdmin() ? <Navigate to="/admin" replace /> : <OverviewPage />;
}

function AppContent() {
  return (
    <>
      <Alerts />
      <UserRoleProvider>
        <Routes>
          <Route path="login" element={<LoginPage />} />
          <Route element={<ProtectedRoute />}>
            <Route index element={<HomeRedirect />} />
            <Route path="/detail" element={<DetailPage />} />
            <Route element={<AdminRoute />}>
              <Route path="/admin" element={<AdminOverviewPage />} />
              <Route path="/admin/add" element={<AdminAddBookPage />} />
              <Route path="/admin/edit" element={<AdminEditBookPage />} />
              <Route path="/admin/detail" element={<AdminDetailPage />} />
              <Route path="/users" element={<UserOverviewPage />} />
            </Route>
            <Route path="*" element={<ErrorPage />} />
          </Route>
        </Routes>
      </UserRoleProvider>
    </>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </Router>
  );
}

export default App;